import { fromEvent } from 'rxjs';
import { tap, debounceTime } from 'rxjs/operators';
import HorizontalSlideNavi from '../../component/navi/HorizontalSlideNavi';
import DesktopPaginationNavi from './DesktopPaginationNavi';
import { BREAKPOINTS } from '../../model/model';
import { isMobileResolution, getResolution } from '../../utils/util';

class Pagination {
  constructor(options) {
    const _ = this;
    if (!options) return;

    _.option = $.extend(
      true,
      {
        wrap: null,
        breakpoint: BREAKPOINTS,
        isMobileEnv: false,
        global: window
      },
      options
    );

    _.isMobileEnv = _.option.isMobileEnv;

    // import Dragdealer
    _.Dragdealer = require('../../vendor/dragdealer-v0.9.8/dragdealer');

    _.wrap = null;

    // mobile slideNavi
    _.slideNavi = null;
    _.slideNaviListItems = null;

    // pc navi
    _.desktopNavi = null;

    _.currentIndex = 1;
    _.currentResolution = '';

    _.global = _.option.global || window;

    // fix iPad Chrome resize, orientationchange delay bug
    _.subscribeResizeWindow$ = null;
  }

  init(obj) {
    const _ = this;

    _.wrap = $(_.option.wrap);

    if (_.wrap.length > 0) {
      _.currentResolution = getResolution(_.option.breakpoint, _.global);

      _.setInstance();
    }

    return _;
  }

  setInstance() {
    const _ = this;

    if (isMobileResolution(_.currentResolution)) {
      _.setSlideNavi();

      $('.btn-prev-mobile').on('click', (e)=>{
        let idx = _.currentIndex;
        idx = idx <= 1 ? 0 : idx - 1;

        $(_).trigger({
          type: Pagination.CLICK_PAGE_BTN,
          index: idx
        });
      });
      
      $('.btn-next-mobile').on('click', (e)=>{
        let idx = _.currentIndex;
        idx = idx > _.slideNavi.getBtns().length ? 0 : idx + 1;

        $(_).trigger({
          type: Pagination.CLICK_PAGE_BTN,
          index: idx
        });
      });
    } else {
      _.setDesktopNavi();
    }

    if (_.isMobileEnv) {
      // trigger mobile device browser resize delay
      _.subscribeResizeWindow$ = fromEvent(window, 'resize')
        .pipe(
          debounceTime(100),
          tap(evt => _.resize())
        )
        .subscribe();
    } else {
      $(_.global).on(
        'resize.ui.pagination orientationchange.ui.pagination',
        $.proxy(_.resize, _)
      );
    }

    _.resize();
  }

  setSlideNavi() {
    const _ = this;

    let slideNaviWrap = $('.pagination-mobile', _.wrap),
      btnsWrap = $('.btns', slideNaviWrap);

    // set list items width.
    _.slideNaviListItems = $('li', btnsWrap);
    _.setSlideNaviListItemsWidth(_.slideNaviListItems.length);

    // set slideNavi
    _.slideNavi = new HorizontalSlideNavi({
      Dragdealer: _.Dragdealer,

      // Navi.js options
      btns: $('li a', btnsWrap),

      clickCallback: function(obj) {
        const index = obj.index,
          activatedIndex = _.slideNavi.getActivatedIndex();
        if (index === activatedIndex) return;

        _.currentIndex = obj.index;

        $(_).trigger({
          type: Pagination.CLICK_PAGE_BTN,
          index: obj.index
        });
      },

      activateCallback: function(obj) {
        _.activateSlideNaviBtn(obj.index);
      },

      // HorizontalSlideNavi.js options
      wrap: slideNaviWrap,
      handleClass: 'handle',
      btnsWrap: btnsWrap
    });
    _.slideNavi.init();

    if (_.slideNaviListItems.length <= 2) _.slideNavi.disable();

  }

  setDesktopNavi() {
    const _ = this;

    _.desktopNavi = new DesktopPaginationNavi({
      wrap: $('.pagination-pc', _.wrap),

      clickCallback: function(obj) {
        console.log(_.currentIndex, obj)
        const index = obj.index,
          activatedIndex = _.desktopNavi.getActivatedIndex();
        if (index === activatedIndex) return;

        _.currentIndex = obj.index;

        $(_).trigger({
          type: Pagination.CLICK_PAGE_BTN,
          index: obj.index
        });
      },

      firstIndex: _.currentIndex,

      global: _.global
    });
    _.desktopNavi.init();

    $(_.desktopNavi).on(DesktopPaginationNavi.CLICK_PREVNEXT_BTN, function(
      evt
    ) {
      const index = evt.index,
        direction = evt.direction;

      _.desktopNavi.switchBtns(direction, index);

      $(_).trigger({
        type: Pagination.CLICK_PAGE_BTN,
        index: index
      });
    });
  }

  resize(evt) {
    const _ = this,
      breakpoint = _.option.breakpoint;

    if (breakpoint.max && _.global.innerWidth >= breakpoint.max) {
      if (_.slideNavi) {
        _.slideNavi.destroy();
        _.slideNavi = null;
      }

      if (!_.desktopNavi) _.setDesktopNavi();
      _.desktopNavi.activate(_.currentIndex);
    } else if (breakpoint.pc && _.global.innerWidth >= breakpoint.pc) {
      if (_.slideNavi) {
        _.slideNavi.destroy();
        _.slideNavi = null;
      }

      if (!_.desktopNavi) _.setDesktopNavi();
      _.desktopNavi.activate(_.currentIndex);
    } else if (breakpoint.tablet && _.global.innerWidth >= breakpoint.tablet) {
      if (_.desktopNavi) {
        _.desktopNavi.destroy();
        _.desktopNavi = null;
      }

      if (!_.slideNavi) _.setSlideNavi();
      _.slideNavi.activate(_.currentIndex);
      _.setSlidePositionByIndex(_.currentIndex);

      if (_.slideNaviListItems.length > 2) _.slideNavi.enable();
      _.setSlideNaviListItemsWidth(_.slideNaviListItems.length);
    } else {
      if (_.desktopNavi) {
        _.desktopNavi.destroy();
        _.desktopNavi = null;
      }

      if (!_.slideNavi) _.setSlideNavi();
      _.slideNavi.activate(_.currentIndex);
      _.setSlidePositionByIndex(_.currentIndex);

      _.slideNavi.disable();
      _.setSlideNaviListItemsWidth(_.slideNaviListItems.length);
    }
  }

  activateSlideNaviBtn(index) {
    const _ = this,
      btns = $(_.slideNavi.getBtns()),
      btn = $(_.slideNavi.getBtn(index));

    btns.removeClass('on');
    btn.addClass('on');
  }

  setSlidePositionByIndex(index) {
    const _ = this;
    if (!_.slideNavi) return;

    _.slideNavi.activate(index);

    if (index < 1 || index > _.slideNavi.getBtns().length) return;

    const prev = index <= 1 ? 0 : index - 1,
      next = index > _.slideNavi.getBtns().length ? 0 : index + 1;

    if (!prev) {
      // go to left end.
      _.slideNavi.setRatioX(0);
      return;
    }

    if (!next) {
      // go go right end.
      _.slideNavi.setRatioX(1);
      return;
    }

    const btn = $(_.slideNavi.getBtn(prev));
    if (btn.length) _.slideNavi.setX(-btn.position().left);
  }

  setSlideNaviListItemsWidth(itemLength) {
    const _ = this;
    if (_.slideNaviListItems.length)
      _.slideNaviListItems.width(_.getSlideNaviListItemWidth(itemLength));
  }

  getSlideNaviListItemWidth(itemLength) {
    const width = this.global.innerWidth;
    if (itemLength <= 1) return width;

    return width / 2;
  }

  /*
   * public methods
   */
  activate(index, direction) {
    const _ = this;

    if (_.slideNavi) {
      _.activateSlideNaviBtn(index);
      _.setSlidePositionByIndex(index);
    }

    if (_.desktopNavi) {
      if (direction) _.desktopNavi.switchBtns(direction, index);
      _.desktopNavi.activate(index);
    }

    _.currentIndex = index;
  }
}
Pagination.CLICK_PAGE_BTN = 'CLICK_PAGE_BTN';

export default Pagination;



// WEBPACK FOOTER //
// ./_src/js/main/promotionBanner/Pagination.js